<template>
  <Modal v-model="visible" title="新增" width="630" :mask-closable="false" :footer-hide="true" class="my-modal top">
    <Form v-if="visible" ref="form" :model="formData" class="page-form less" :label-width="75">
      <FormItem label="机构" key="orgIds" prop="orgIds" class="full" :rules="$units.formRule.required('请选择',trigger = 'change',type = 'array')" v-if="userInfo.levelCode != '10002'">
        <Select v-model="formData.orgIds" @on-change="changeOrg" multiple :transfer="true">
          <Option :value="item.id" v-for="item in orgList" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label="产品名称" prop="productCodes" class="full" key="productCodes1" :rules="$units.formRule.required('请选择',trigger = 'change',type = 'array')">
        <Select v-model="formData.productCodes" multiple @on-open-change="openChenge" filterable :max-tag-count="10" :transfer="true">
          <Option v-for="item in productList" :value="item.productCode" :key="item.productCode">{{ item.productName }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
import selectTree from "@/components/system/selectTree2";
import filter from "@/api/filter";
export default {
  props:['getProductList', 'userInfo'],
  components:{selectTree},
  data() {
    return {
      filter,
      visible:false,
      formData:{},
      productList:[],
      orgList:[],
      loading:false
    }
  },
  methods:{
    async open(){
      this.visible = true;
      this.formData = {
        orgIds:[],
        productCodes:[]
      }
      this.queryOrgList();
    },
    
    // 机构查询
    queryOrgList() {
      this.$http({
        url: '/buz/organizationBase/read/sub',
        data:{},
        type: "POST",
      }).then((res) => {
        this.orgList = res.data;
      })
    },

    changeOrg() {
      this.productList = [];
      this.$http({
        url: "/buz/hotProductConfig/read/canAdd",
        type: "POST",
        data: {
          orgIds:this.userInfo.levelCode != '10002'?this.formData.orgIds:[this.userInfo.organId]
        }
      }).then(res=>{
        this.productList = res.data;
      })
    },

    // 展开产品下拉
    openChenge(value) {
      if(value && this.formData.orgIds){
        this.$http({
          url: "/buz/hotProductConfig/read/canAdd",
          type: "POST",
          data: {
            orgIds:this.userInfo.levelCode != '10002'?this.formData.orgIds:[this.userInfo.organId]
          }
        }).then(res=>{
          this.productList = res.data;
        })
      }
    },

    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        this.loading = true;
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(this.userInfo.levelCode == '10002'){
          formData.orgIds = [this.userInfo.organId]
        }

        this.$http({
          url: "/buz/hotProductConfig/add",
          type: "POST",
          data: formData,
          apiPermissionCode:'operate_3_3'
        }).then(res=>{
          this.visible = false;
          this.loading = false;
          this.$notice.success("新增成功");
          this.getProductList();
        }).catch(res=>{
          this.loading = false;
        })       
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-modal {
  
  
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
    }
  }
  .info-text {
    font-size: 12px;
    line-height: 1.5;
    padding-top: 5px;
    color: #ccc;
  }
  .product-title {
    margin-right: 15px;
    font-size: 12px;
  }
  .select-product-btn {
    width: 60px;
    height: 25px;
    line-height: 25px;
    margin-top: 2px;
  }
}
</style>